import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var UserGroup = /*#__PURE__*/function () {
  function UserGroup(context) {
    _classCallCheck(this, UserGroup);

    this.context = context;
  }

  _createClass(UserGroup, [{
    key: "getAll",
    value: function getAll() {
      return this.context.http.get('/msvc/v1/usergroups/');
    }
  }]);

  return UserGroup;
}();

export default UserGroup;